module.exports = __webpack_public_path__ + "img/logo-sv-min.9db2266f.svg";